export default __webpack_public_path__ + "static/media/LorenzoHanssens.d4aae1cf.webp";